module.exports = __webpack_public_path__ + "img/capa1.5ffb8bb1.webp";